// @ts-nocheck
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface StoreSearchResultProps {
    title?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
    note?: TypographyPresentationProps;
}

const searchResultProps: StoreSearchResultProps = {
    title: {
        css: css`
            margin-top: ${pxToRem(10)};
            margin-bottom: ${pxToRem(5)};
            color: ${getColor("primary")};
            font-weight: ${x => x.theme.design.typography.weight.medium};
        `,
    },
    link: {
        typographyProps: {
            ellipsis: true,
            css: css`
                width: 100%;
                margin: ${pxToRem(5)} 0;
            `,
        },
        css: css`
            ${linkStyles("primary", "primary", false, true)}
            width: 100%;
        `,
    },
    focusedLink: {
        typographyProps: {
            ellipsis: true,
            css: css`
                width: 100%;
                margin: ${pxToRem(5)} 0;
            `,
        },
        css: css`
            width: 100%;
            overflow: hidden;
            background-color: ${getColor("common.accent")};
        `,
    },
    note: {
        italic: true,
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
};

export default searchResultProps;
